<template>
	<div element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" v-loading="loading">
		<el-page-header @back="goBack" content="观课记录"></el-page-header>
		<div class="pinjhu">
			<div>
				<span class="daxiao">{{data.courseName}}</span>
				<span class="guanjuf" @click="kandian">观看课程</span>
			</div>
			<el-row :gutter="20"  class="pinjhu huisedfas">
				<el-col :span="4" >
					学校：{{data.schoolName}}
				</el-col>
				<el-col :span="4" >
					主讲：{{data.courseSpeaker}}
				</el-col>
				<el-col :span="4" >
					时间：{{data.createTime}}
				</el-col>
			</el-row>
		</div>
		<div class="pinjhu">
			<el-row :gutter="20">
				<el-col :span="2" v-for="(list,index) in lessonVos" :key="index">
					<div
						class="yuedi"
						:class="listindex==list.lessonId?'hongse':''"
						@click="kaiquan(list.lessonId)"
					>{{list.lessonName}}</div>
				</el-col>
			</el-row>
			<div v-for="(list,index) in courseNotes" :key="index" v-if="listindex==list.lessonId">
				<quill-editor
					v-model="list.noteContent"
					ref="myQuillEditor"
					class="editor"
					:options="editorOption"
					@blur="onEditorBlur($event)"
					@focus="onEditorFocus($event)"
					@change="onEditorChange($event)"
				></quill-editor>
				<!-- <div class="pinjhu">
					感受与收获
					<el-input
						type="textarea"
						:rows="8"
						placeholder="请输入感受与收获"
						v-model="list.noteContent"
						class="pinjhu"
					></el-input>
				</div> -->
				<div class="pinjhu">
					总结评价
					<el-input
						type="textarea"
						:rows="8"
						placeholder="请输入总结评价"
						v-model="list.noteEvaluate"
						class="pinjhu"
					></el-input>
				</div>
				<div class="xiamip">
					<span
						class="keshji huidina"
						@click="notesaveevaluate(list.noteContent,list.noteEvaluate,list.noteId)"
					>保存</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { course, noteid, notesaveevaluate } from '@/api/home'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
// 工具栏配置
const toolbarOptions = [
	['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
	['blockquote', 'code-block'], // 引用  代码块-----['blockquote', 'code-block']
	[{ header: 1 }, { header: 2 }], // 1、2 级标题-----[{ header: 1 }, { header: 2 }]
	[{ list: 'ordered' }, { list: 'bullet' }], // 有序、无序列表-----[{ list: 'ordered' }, { list: 'bullet' }]
	[{ script: 'sub' }, { script: 'super' }], // 上标/下标-----[{ script: 'sub' }, { script: 'super' }]
	[{ indent: '-1' }, { indent: '+1' }], // 缩进-----[{ indent: '-1' }, { indent: '+1' }]
	[{ direction: 'rtl' }], // 文本方向-----[{'direction': 'rtl'}]
	[{ size: ['small', false, 'large', 'huge'] }], // 字体大小-----[{ size: ['small', false, 'large', 'huge'] }]
	[{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题-----[{ header: [1, 2, 3, 4, 5, 6, false] }]
	[{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色-----[{ color: [] }, { background: [] }]
	[{ font: [] }], // 字体种类-----[{ font: [] }]
	[{ align: [] }], // 对齐方式-----[{ align: [] }]
	['clean'], // 清除文本格式-----['clean']
	// ['image'], // 链接、图片、视频-----['link', 'image', 'video']
]
export default {
	data() {
		return {
			loading: false,
			id: '',
			lessonVos: [],
			listindex: '',
			courseNotes: [],
			data:[],
			editorOption: {
				placeholder: '请输入感受与收获...',
				theme: 'snow',
				modules: {
					toolbar: {
						container: toolbarOptions,
					},
				},
			},
		}
	},
	watch: {},
	methods: {
		// 失去焦点
		onEditorBlur() {
			// 失去焦点事件
		},
		onEditorFocus() {
			// 获得焦点事件
		},
		onEditorChange() {
			// 内容改变事件
		},
		goBack() {
			this.$router.go(-1)
		},
		course() {
			let that = this
			that.loading = true
			let params = {
				id: that.id,
			}
			course(params)
				.then((res) => {
					that.loading = false
					that.lessonVos = res.data.data.lessonVos
					that.data=res.data.data
					that.listindex = res.data.data.lessonVos[0].lessonId
				})
				.catch(() => {
					that.loading = false
				})
		},
		kaiquan(s) {
			this.listindex = s
		},
		noteid() {
			let that = this
			that.loading = true
			let params = {
				id: that.id,
			}
			noteid(params)
				.then((res) => {
					that.loading = false
					that.courseNotes = res.data.data.courseNotes
				})
				.catch(() => {
					that.loading = false
				})
		},
		notesaveevaluate(s, d, z) {
			let that = this
			that.loading = true
			let params = {
				noteContent: s,
				noteEvaluate: d,
				noteId: z,
			}
			notesaveevaluate(params)
				.then((res) => {
					that.loading = false
					that.$message({
						message: '保存成功',
						type: 'success',
					})
				})
				.catch(() => {
					that.loading = false
					this.$message('保存失败')
				})
		},
		kandian(){
			let routeData = this.$router.resolve({ path: '/index' ,query: { id: this.listindex }});
 			window.open(routeData.href, '_blank');
		}
	},
	components: { quillEditor },
	computed: {},
	beforeMount: function () {},
	mounted() {
		this.id = this.$route.query.id
		this.course()
		this.noteid()
	},
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/index/period.vue